// @flow
import * as React from 'react'
import moment from 'moment'
import type { Gathering } from 'types'
import { Button } from 'ui/Form'
// eslint-disable-next-line import/extensions
import GatheringRegistrationModal from 'main/components/school/GatheringRegistrationModal'
import { type Registration } from '../../../../gql/school/'

export const QUERY_AGES = 'ages'
export const QUERY_OPEN = 'open'
export const QUERY_QUANTITY = 'quantity'
export const QUERY_SEARCHING = 'searching'

type Props = {
  gathering: Gathering,
  registration: Registration[],
}

type State = {
  isSaved: boolean,
  gatheringAuthModal: boolean,
}

type ButtonType = 'ended' | 'registered' | 'full' | 'interested'

const ENDED_BUTTON: ButtonType = 'ended'
const REGISTERED_BUTTON: ButtonType = 'registered'
const FULL_BUTTON: ButtonType = 'full'
const INTERESTED_BUTTON: ButtonType = 'interested'

export default class RegisterButton extends React.Component<Props, State> {
  state: State = {
    gatheringAuthModal: false,
    isSaved: false,
  }

  render = () => {
    return (
      <React.Fragment>
        {this.renderButtonMaybe()}
        {this.renderModalMaybe()}
      </React.Fragment>
    )
  }

  renderButtonMaybe = () => {
    switch (this.buttonType) {
      case ENDED_BUTTON:
        return this.renderEndedButton()
      case REGISTERED_BUTTON:
        return this.renderRegisteredButton()
      case FULL_BUTTON:
        return this.renderFullButton()
      case INTERESTED_BUTTON:
        return this.renderInterestedButton()
      default:
        return null
    }
  }

  renderEndedButton = () => {
    return (
      <Button large full appearance="neutral">
        Event has ended
      </Button>
    )
  }

  renderRegisteredButton = () => {
    if (!this.props.registration[0]) return null

    return (
      <Button
        large
        full
        appearance="white"
        onClick={() => this.setState({ gatheringAuthModal: true })}
      >
        <svg width="18" height="16" viewBox="0 0 18 16" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 7.705l5.626 4.893L16.26 2" strokeWidth="4" stroke="#000" fill="none" />
        </svg>{' '}
        RSVP'd for {this.props.registration[0].quantity}
      </Button>
    )
  }

  renderFullButton = () => {
    return (
      <Button large full appearance="neutral">
        Event full
      </Button>
    )
  }

  renderInterestedButton = () => {
    return (
      <Button
        large
        full
        onClick={() => this.setState({ gatheringAuthModal: true })}
        data-pendo="eventRsvpCta"
      >
        I'm Interested
      </Button>
    )
  }

  renderModalMaybe = () => {
    if (!this.state.gatheringAuthModal) return null

    const { gathering } = this.props

    return (
      <GatheringRegistrationModal
        registration={this.props.registration[0]}
        gathering={gathering}
        schoolId={gathering.schoolId}
        onRequestClose={() =>
          this.setState({
            gatheringAuthModal: false,
          })
        }
      />
    )
  }

  get hasEnded(): boolean {
    return moment(this.props.gathering.endsAt).isBefore(moment())
  }

  get buttonType(): ButtonType | null {
    const { capacity, registeredQuantity } = this.props.gathering

    if (this.hasEnded) return ENDED_BUTTON
    if (this.props.registration[0]) return REGISTERED_BUTTON
    if (capacity && registeredQuantity && capacity <= registeredQuantity) return FULL_BUTTON
    return INTERESTED_BUTTON
  }
}
